// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .height-no-compatible-content {
  position: absolute;
  display: block;
  background-color: var(--color-surface);
  top: 0;
  left: 0;
  z-index: 10000000;
  width: 100vw;
  height: 100vh;
}
:host .height-no-compatible-content * {
  box-sizing: border-box;
}
:host .height-no-compatible-content body {
  padding: 0;
  margin: 0;
  color: black !important;
}
:host .height-no-compatible-content #no-compatible {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
}
:host .height-no-compatible-content .no-compatible {
  max-width: 520px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
}
:host .height-no-compatible-content .no-compatible h2 {
  font-family: "DM Sans", sans-serif;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-regular);
  text-transform: uppercase;
  color: #000;
  margin-top: 0px;
  margin-bottom: 25px;
}
@media only screen and (max-width: 480px) {
  :host .height-no-compatible-content .no-compatible h2 {
    font-size: var(--font-size-md);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/height-no-compatible/height-no-compatible.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,cAAA;EACA,sCAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;EAEA,YAAA;EACA,aAAA;AADR;AAKQ;EAEI,sBAAA;AAHZ;AAMQ;EACI,UAAA;EACA,SAAA;EACA,uBAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AALZ;AAQQ;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AANZ;AASQ;EACI,kCAAA;EACA,8BAAA;EACA,uCAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAPZ;AAUQ;EAEI;IACI,8BAAA;EATd;AACF","sourcesContent":[":host{\r\n    .height-no-compatible-content{\r\n        position: absolute;\r\n        display: block;\r\n        background-color: var(--color-surface);\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 10000000;\r\n\r\n        width: 100vw;\r\n        height: 100vh;\r\n\r\n\r\n\r\n        * {\r\n            -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n        }\r\n\r\n        body {\r\n            padding: 0;\r\n            margin: 0;\r\n            color: black !important;\r\n        }\r\n\r\n        #no-compatible {\r\n            position: relative;\r\n            height: 100vh;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            flex-direction: column;\r\n            gap: 20px;\r\n        }\r\n\r\n        .no-compatible {\r\n            max-width: 520px;\r\n            width: 100%;\r\n            line-height: 1.4;\r\n            text-align: center;\r\n        }\r\n\r\n        .no-compatible h2 {\r\n            font-family: \"DM Sans\", sans-serif;\r\n            font-size: var(--font-size-xl);\r\n            font-weight: var(--font-weight-regular);\r\n            text-transform: uppercase;\r\n            color: #000;\r\n            margin-top: 0px;\r\n            margin-bottom: 25px;\r\n        }\r\n\r\n        @media only screen and (max-width: 480px) {\r\n\r\n            .no-compatible h2 {\r\n                font-size: var(--font-size-md);\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
